module.exports = __webpack_public_path__ + "media/images/illustrations/mover_with_truck-6504e019a9cfcd4976814b082ab4c5aa.svg";